import { createFileRoute, notFound, useParams } from '@tanstack/react-router'

import { staticPageQueries } from 'lib/queries'

import StaticPage from 'pages/StaticPage/StaticPage'

export const Route = createFileRoute('/$slug')({
  loader: async ({ params, context }) => {
    let index
    try {
      index = await context.queryClient.ensureQueryData(
        staticPageQueries.index(),
      )
    } catch {
      throw notFound()
    }
    const exists = index.pages?.some((p) => p.slug === params.slug)
    if (!exists) throw notFound()
    return context.queryClient.ensureQueryData(
      staticPageQueries.bySlug(params.slug),
    )
  },
  component: StaticPageRoute,
})

function StaticPageRoute() {
  const { slug } = useParams({ from: '/$slug' })
  return <StaticPage slug={slug} />
}
